import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

// [ANTIGRAVITY] Helper to generate consistent media URLs for flows
export const getMediaUrl = (filename, companyId = 1) => {
	if (!filename || filename === "" || filename === "null") return "";

	// 1. Extraer solo el nombre del archivo (quitar rutas C:\ o /)
	const cleanName = filename.split(/[/\\]/).pop();

	// 2. Codificar CADA PARTE para que los espacios se vuelvan %20, etc.
	const encodedName = encodeURIComponent(cleanName);

	const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";
	const baseUrl = backendUrl.endsWith("/") ? backendUrl.slice(0, -1) : backendUrl;

	return `${baseUrl}/public/company${companyId}/flow/${encodedName}`;
};

export default api;
